import _api from "./lib/api";
import _keccak from "./lib/keccak";
var exports = {};
exports = _api(_keccak);
export default exports;